export default "__VITE_ASSET__DUOtgx6f__"